/* VroomCam PDP v2 — AJAX Cart + Drawer + Variants */
(function () {
  'use strict';

  /* App Detection */
  function hasCartApp() {
    return !!(window.KaChinka || window.AfterSell || window.BOLD ||
      document.querySelector('[data-kachinka],[data-aftersell]'));
  }

  /* Money (fallback formatter, EUR) */
  function vcMoney(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  /* Currency-aware money formatter (uses the cart's presentment currency) */
  function vcMoneyCur(cents, currency) {
    if (currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {}
    }
    return vcMoney(cents);
  }

  /* Badge updates */
  function updateBadges(count) {
    document.querySelectorAll('.vc-cart-badge').forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* Cart Drawer */
  function vcCartOpen() {
    vcCartRefresh();
    var ov = document.getElementById('vc-cart-overlay');
    var dr = document.getElementById('vc-cart-drawer');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    document.body.classList.add('vc-no-scroll');
  }

  window.vcCartClose = function () {
    var ov = document.getElementById('vc-cart-overlay');
    var dr = document.getElementById('vc-cart-drawer');
    if (ov) ov.classList.remove('open');
    if (dr) dr.classList.remove('open');
    document.body.classList.remove('vc-no-scroll');
  };

  window.vcCartUpdateQty = function (key, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadges(cart.item_count);
        vcCartRefresh();
      });
  };

  function vcCartRefresh() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadges(cart.item_count);
        var cur = cart.currency;
        var countEl = document.getElementById('vc-drawer-count');
        if (countEl) countEl.textContent = cart.item_count;
        var itemsEl = document.getElementById('vc-cart-drawer-items');
        if (!itemsEl) return;
        var footEl = document.getElementById('vc-cart-drawer-foot');
        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p class="vc-cart-empty">Your cart is empty.</p>';
          if (footEl) footEl.style.display = 'none';
          return;
        }
        if (footEl) footEl.style.display = '';
        itemsEl.innerHTML = cart.items.map(function (item) {
          var vt = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="vc-ci__variant">' + item.variant_title + '</div>' : '';
          var img = item.image
            ? '<img src="' + item.image.replace('http:', 'https:') + '" alt="" class="vc-ci__img">'
            : '<div class="vc-ci__img vc-ci__img--empty"></div>';
          return '<div class="vc-cart-item">' + img +
            '<div class="vc-ci__body"><div class="vc-ci__title">' + item.product_title + '</div>' + vt +
            '<div class="vc-ci__price">' + vcMoneyCur(item.final_line_price, cur) + '</div></div>' +
            '<div class="vc-ci__qty">' +
            '<button onclick="vcCartUpdateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">&#8722;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button onclick="vcCartUpdateQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">&#43;</button>' +
            '</div></div>';
        }).join('');
        var subEl = document.getElementById('vc-drawer-subtotal');
        if (subEl) subEl.textContent = vcMoneyCur(cart.total_price, cur);
      });
  }

  /* Inline error */
  function vcShowError(container, msg) {
    var old = container.querySelector('.vc-cart-error');
    if (old) old.remove();
    var el = document.createElement('p');
    el.className = 'vc-cart-error';
    el.textContent = msg;
    container.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 5000);
  }

  /* AJAX Add to Cart */
  function vcAddToCart(form, btn) {
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (d) {
            throw new Error(d.description || d.message || 'Could not add to cart.');
          });
        }
        return r.json();
      })
      .then(function () {
        if (btn) { btn.textContent = '✓ Added!'; }
        vcCartRefresh();
        vcCartOpen();
        setTimeout(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        }, 2000);
      })
      .catch(function (err) {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
        vcShowError(form, (err && err.message) ? err.message : 'Could not add to cart. Please try again.');
      });
  }

  /* Form intercept */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.id) return;
    var isVcForm = form.id === 'vc-product-form' || form.id === 'vc-final-form' ||
      (form.id.indexOf('vc-') === 0 && form.id.slice(-5) === '-form');
    if (!isVcForm) return;
    e.preventDefault();
    vcAddToCart(form, form.querySelector('[type="submit"]'));
  });

  /* Variant pill selection */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.pdp-hero__opt-pill');
    if (!pill) return;
    var group = pill.closest('.pdp-hero__opt-group');
    if (!group) return;
    group.querySelectorAll('.pdp-hero__opt-pill').forEach(function (p) { p.classList.remove('active'); });
    pill.classList.add('active');
    var lbl = group.querySelector('.pdp-hero__opt-selected');
    if (lbl) lbl.textContent = pill.dataset.value;
    var form = pill.closest('form');
    if (!form) return;
    var selections = [];
    form.querySelectorAll('.pdp-hero__opt-group').forEach(function (g) {
      var ap = g.querySelector('.pdp-hero__opt-pill.active');
      if (ap) selections.push(ap.dataset.value);
    });
    var dataEl = form.querySelector('[data-product-variants]');
    if (!dataEl) return;
    try {
      var variants = JSON.parse(dataEl.textContent.trim());
      var match = variants.find(function (v) {
        return selections.every(function (sel, i) { return v['option' + (i + 1)] === sel; });
      });
      if (match) {
        // Update all product forms with the new variant ID
        document.querySelectorAll('input[name="id"]').forEach(function(hid){ hid.value = match.id; });
        // Look up the server-rendered, currency-correct price strings for this variant
        var priceInfo = null;
        var priceMapEl = document.querySelector('[data-vc-variant-prices]');
        if (priceMapEl) {
          try { priceInfo = JSON.parse(priceMapEl.textContent.trim())[match.id]; } catch (mapErr) {}
        }
        var priceStr = priceInfo ? priceInfo.price : vcMoney(match.price);
        var compareStr = priceInfo ? priceInfo.compare
          : ((match.compare_at_price && match.compare_at_price > match.price) ? vcMoney(match.compare_at_price) : null);
        var priceEl = document.getElementById('vc-hero-price');
        if (priceEl) priceEl.textContent = priceStr;
        var cmpEl = document.getElementById('vc-hero-compare');
        if (cmpEl) {
          if (compareStr) {
            cmpEl.textContent = compareStr;
            cmpEl.style.display = '';
          } else {
            cmpEl.style.display = 'none';
          }
        }
        var stickyEl = document.querySelector('[data-vc-sticky-amount]');
        if (stickyEl) stickyEl.textContent = priceStr;
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          if (!match.available) {
            submitBtn.textContent = 'Sold Out';
            submitBtn.disabled = true;
          } else {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.addText || 'Add to Cart';
          }
        }
        // Update main gallery image when variant has a featured image
        if (match.featured_image && match.featured_image.src) {
          var mainImg = document.getElementById('vc-main-img');
          if (mainImg) { mainImg.src = match.featured_image.src; mainImg.alt = match.featured_image.alt || ''; }
          document.querySelectorAll('.pdp-hero__thumb').forEach(function(t){ t.classList.remove('active'); });
        }
      }
    } catch (err) { console.warn('Variant error:', err); }
  });

  /* Gallery */
  window.vcSetImg = function (thumb, src, alt) {
    var m = document.getElementById('vc-main-img');
    if (m) { m.src = src; m.alt = alt; }
    document.querySelectorAll('.pdp-hero__thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

  /* FAQ accordion */
  window.vcFaqToggle = function (btn) {
    var item = btn.closest('.vc-faq__item');
    if (!item) return;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.vc-faq__item.open').forEach(function (i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  /* Specs accordion */
  window.vcSpecsToggle = function (btn) {
    var panel = document.getElementById(btn.dataset.target);
    if (!panel) return;
    var open = btn.classList.toggle('open');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
  };

  /* Hamburger */
  function initHamburger() {
    var burger = document.getElementById('vc-burger');
    var mNav = document.getElementById('vc-mobile-nav');
    if (!burger || !mNav) return;
    burger.addEventListener('click', function () {
      var isOpen = mNav.classList.toggle('open');
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', String(isOpen));
    });
    document.addEventListener('click', function (e) {
      if (mNav.classList.contains('open') && !burger.contains(e.target) && !mNav.contains(e.target)) {
        mNav.classList.remove('open');
        burger.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Cart icon → open drawer */
  function initCartBtn() {
    document.querySelectorAll('.vc-header__cart-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        vcCartOpen();
      });
    });
  }

  /* Init */
  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadges(cart.item_count); });
    initHamburger();
    initCartBtn();
  });

})();
